import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { logEventGA4 } from '../../google';
import { migrateReduxSessionStorageFilterValue, sessionStorageMF } from '../../utils';
import { setFilterValue } from '../filterValue';

const initialState = {
  display: 'Tier',
  name: 'doctorTier',
  type: 'multiSelect',
  selected: [],
  selectedVal: [],
  options: [
    { value: 75, display: 'Elite' },
    { value: 50, display: 'Distinguished' },
    { value: 25, display: 'Advanced' },
    { value: 0, display: 'Experienced' },
  ],
};

const storeName = 'doctorTier';
export const useDoctorTierFilter = create(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        set,
        reset: () => set({ ...initialState }, false, { type: 'reset' }),
        getInitialState: () => ({ ...initialState }),
        setFilterValue: (v) => updateDoctorTierFilterOption(v),
      }),
      {
        name: `${process.env.NX_APP}-${storeName}`,
        version: 0,
        storage: createJSONStorage(() => sessionStorageMF),
        onRehydrateStorage: () => (state) => {
          migrateReduxSessionStorageFilterValue({ state, key: 'doctorTier' });
        },
      },
    ),
    {
      name: `${process.env.NX_APP}`,
      store: storeName,
    },
  ),
);

export const updateDoctorTierFilterOption = (option) => {
  if (option && process.env.NX_APP === 'MediFind-Pro') {
    const { value } = option;
    logEventGA4('filter', { type: 'doctor_tier', action: 'select', item_id: value }, '4d606ab2-e103-4919-95a7-bd9d124f8ea8');
  }
  setFilterValue(useDoctorTierFilter, option);
};

export const clearDoctorTierFilterOption = () => useDoctorTierFilter.setState((state) => ({ ...initialState }));
